import axios from "../axios";

class RoleService {

  static Instance() {
    return new RoleService();
  }

  getRoles() {
    return axios.get("/api/role");
  }

}

export default RoleService.Instance();